module.exports = __webpack_public_path__ + "facturtransp.dcd6cc18fedb7e33a9fd.png";


//////////////////
// WEBPACK FOOTER
// D:/Repositorios/FacturacionWeb/src/assets/images/logos/facturtransp.png
// module id = ../../../../../src/assets/images/logos/facturtransp.png
// module chunks = main